import { render, staticRenderFns } from "./AddExamObjectByExcel.vue?vue&type=template&id=5b6d3c18&scoped=true&"
import script from "./AddExamObjectByExcel.vue?vue&type=script&lang=js&"
export * from "./AddExamObjectByExcel.vue?vue&type=script&lang=js&"
import style0 from "./AddExamObjectByExcel.vue?vue&type=style&index=0&id=5b6d3c18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6d3c18",
  null
  
)

export default component.exports